module.exports = __webpack_public_path__ + "img/album18_57.723c309c.jpg";